import * as React from "react";

function ArrowRightCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'current',
    fillRule: "evenodd",
    d: "M16 4C9.372 4 4 9.372 4 16s5.372 12 12 12 12-5.372 12-12S22.628 4 16 4zM2 16C2 8.268 8.268 2 16 2s14 6.268 14 14-6.268 14-14 14S2 23.732 2 16zm14.707-6.041L22.747 16l-6.04 6.04-1.414-1.414L18.919 17h-8.253v-2h8.253l-3.626-3.627 1.414-1.414z",
    clipRule: "evenodd"
  }));
}

export default ArrowRightCircleIcon;